export default from './badge';



// WEBPACK FOOTER //
// ./app/components/badge/index.js